'use client'

import { useAction } from 'next-safe-action/hooks'

import { validatePhoneNumber as _validatePhoneNumber } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

export const useValidatePhoneNumber = ({
  onSuccess,
}: {
  onSuccess?: (phoneNumber: string) => void
} = {}) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_validatePhoneNumber, {
    onSuccess: ({ data }) => {
      if (data?.phoneNumber) {
        onSuccess?.(data.phoneNumber)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const validatePhoneNumber = (phoneNumber: string) => {
    action.execute({ phoneNumber })
  }

  const validatePhoneNumberAsync = async (phoneNumber: string) => {
    const result = await action.executeAsync({ phoneNumber })

    if (result?.serverError) {
      return false
    }

    return true
  }

  return { validatePhoneNumber, validatePhoneNumberAsync }
}
